import React from 'react'

import {
  FieldSpec,
  DateTimeField,
  LinkedField,
  PaginatedTable,
  RelatedLinkedField,
  ValueField,
} from 'src/components/Table'
import { ListTableProps } from './types'

const fieldOptions: { [key: string]: FieldSpec } = {
  name: { id: 'name', label: 'Appointment', renderer: LinkedField(ValueField) },
  start: { id: 'start', label: 'Start Time', renderer: DateTimeField },
  end: { id: 'end', label: 'End Time', renderer: DateTimeField },
  facility: { id: 'facility', label: 'Facility', renderer: RelatedLinkedField(ValueField, 'name') },
  status: { id: 'status', label: 'Status', renderer: ValueField },
}

export const AppointmentListTable = (props: ListTableProps) => {
  const { paginator, fields } = props

  return (
    <>
      <PaginatedTable
        title="Appointments"
        fields={fields.map((field) => fieldOptions[field])}
        paginator={paginator}
      />
    </>
  )
}
